// extracted by mini-css-extract-plugin
export default {"container":"style_container__0V3Nr","toggleSwitch":"style_toggleSwitch__xNfd9","slider":"style_slider__Sk9Jd","label":"style_label__iAmj9"};